import { useState } from "react";
import "./index.css";

export default function App() {
	const [bill, setBill] = useState("");
	const [tipSelected, setTipSelected] = useState("");
	const [count, setCount] = useState(1);

	const tipPerPerson = (bill * (tipSelected / 100)) / count;
	const totalPerPerson = (bill + tipPerPerson * count) / count;

	function reset() {
		setBill("");
		setTipSelected("");
		setCount("");
	}

	return (
		<div className="App">
			<div className="title">
				<p>SPLI</p>
				<p>TTER</p>
			</div>
			<main className="container">
				<div className="input-div">
					<Bill bill={bill} onSetBill={setBill} />
					<TipSelection
						tipSelected={tipSelected}
						setTipSelected={setTipSelected}
					/>
					<CountOfPeople count={count} setCount={setCount} />
				</div>
				<div className="result-div">
					<TipAmount tipPerPerson={tipPerPerson} />
					<Total totalPerPerson={totalPerPerson} />
					<Button reset={reset}>RESET</Button>
				</div>
			</main>
		</div>
	);
}

function Bill({ bill, onSetBill }) {
	return (
		<div>
			<p className="margin-bottom">Bill</p>
			<input
				type="number"
				placeholder="$"
				value={bill}
				onChange={(e) => onSetBill(Number(e.target.value))}
			></input>
		</div>
	);
}

function TipSelection({ tipSelected, setTipSelected }) {
	// console.log(tipSelected);
	return (
		<div>
			<p className="margin-bottom">Select tip %</p>
			<div className="tip-selection-grid">
				<button value={5} onClick={(e) => setTipSelected(e.target.value)}>
					5%
				</button>
				<button value={10} onClick={(e) => setTipSelected(e.target.value)}>
					10%
				</button>
				<button value={15} onClick={(e) => setTipSelected(e.target.value)}>
					15%
				</button>
				<button value={25} onClick={(e) => setTipSelected(e.target.value)}>
					25%
				</button>
				<button value={50} onClick={(e) => setTipSelected(e.target.value)}>
					50%
				</button>
				<input
					type="text"
					placeholder="Custom"
					value={tipSelected}
					onChange={(e) => setTipSelected(Number(e.target.value))}
				/>
			</div>
		</div>
	);
}

function CountOfPeople({ count, setCount }) {
	return (
		<div>
			<p className="margin-bottom">Number of people</p>
			<input
				type="number"
				placeholder="?"
				value={count}
				onChange={(e) => setCount(Number(e.target.value))}
			/>
		</div>
	);
}

function TipAmount({ tipPerPerson }) {
	console.log(Number.isInteger(tipPerPerson));
	return (
		<div className="tip-amount-flex">
			<div>
				<p className="result-div-writing">Tip amount</p>
				<p className="per-person">/person</p>
			</div>
			<p className="result">
				${Number.isFinite(tipPerPerson) ? tipPerPerson.toFixed(2) : 0}
			</p>
		</div>
	);
}
function Total({ totalPerPerson }) {
	return (
		<div className="total-amount-flex">
			<div>
				<p className="result-div-writing">Total amount</p>
				<p className="per-person">/person</p>
			</div>
			<p className="result">
				${Number.isFinite(totalPerPerson) ? totalPerPerson.toFixed(2) : 0}
			</p>
		</div>
	);
}

function Button({ reset, children }) {
	return (
		<button className="btn" onClick={reset}>
			{children}
		</button>
	);
}
